import config from '../config';
const loginDirect = `${config.loginDirect}${encodeURIComponent(`${location.href}`)}`;

let getInviteInfo;
let toBind;
const getInviteCode = () => {
  return location.pathname.split('/index.html/confirm/')[1];
}

const inviteCode = getInviteCode();

export default {
	start: () => {
		if (!inviteCode) return;
		$.ajax({
		  url: '/api/account/getUserInfo',
		  method: 'get',
		  contentType: "application/json",
		  dataType: "json",
		  success: (data) => {
		    if (data && +data.code === 200 && data.msg === 'ok') {
		      const { businessName, businessId } = data.data.businessInfo;
		      const { userType, userName } = data.data.userInfo;
		      if (businessId && businessName && userType === 'M') {
		        getInviteInfo(businessName, businessId, userType);
		      } else if (businessId && businessName) {
		        getInviteInfo(businessName, businessId, userType);
		      } else {
		        getInviteInfo();
		        toBind();
		      }
		    } else {
		      $('.inviteFailed').show();
		    }
		  },
		  error: (err) => {
		    // 请求失败
		    console.log('error', err);
		  }
		});

		getInviteInfo = (businessName, businessId, userType) => {
		  $.ajax({
		    url: '/api/account/invitation?code=' + inviteCode,
		    method: 'get',
		    contentType: "application/json",
		    dataType: "json",
		    success: (data) => {
		      if (data && +data.code === 200 && data.succeed) {
		      	if (data.data && data.data.businessName === businessName && businessId) {
							$('.modal-card').addClass('show');
		      		$('.isBizUser').show();
		      	} else if (businessName && businessId) {
		      		if (userType === 'M') {
		      			$('.modal-card').addClass('show');
		      			$('.adminInvite').show();
		      		} else {
								$('.modal-card').addClass('show');
								$('.failedInvite').show();
		      		}
		      	}
		      } else {
		        // $('.inviteFailed').show();
		        // $('.inviteinfo').hide();
		      }
		    },
		    error: (err) => {
		      // 请求失败
		      console.log('error', err);
		    }
		  });
		}

		$('.cancelBtn').click(() => {
		  // location.href = config.httpProtocol + config.webUrl + '/index.html';
		  $('.modal-card').removeClass('show');
		});

		$('.unBindBtn').click(() => {
		  toBind();
		});
		$('.adminBtn').click(() => {
			$('.modal-card').removeClass('show');
		});

		toBind = () => {
			$('.card-content').hide();
		  $('.binding').show();
		  $.ajax({
		    url: '/api/account/bind',
		    method: 'post',
		    contentType: "application/json",
		    dataType: "json",
		    data: JSON.stringify({
		      code: inviteCode
		    }),
		    success: (data) => {
		      if (data && +data.code == 200 && data.succeed) {
		        $('.modal-card').addClass('show');
						$('.successInvite').show();

		        setTimeout(() => {
		          // location.href = config.httpProtocol + config.webUrl + '/index.html';
		      		$('.modal-card').removeClass('show');
		        }, 3000);
		      } else {
		      	$('.modal-card').addClass('show');
		      	$('.bindError').show();

		        setTimeout(() => {
		      		$('.modal-card').removeClass('show');
		          $('.binderror').hide();
		        }, 3000);
		      }
		    },
		    error: (err) => {
		      console.log('error', err);
		      // 请求失败
	      	$('.modal-card').addClass('show');
	      	$('.bindError').show();

		      setTimeout(() => {
		      	$('.modal-card').removeClass('show');
		        $('.binderror').hide();
		      }, 3000);
		    }
		  });
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/finance/invite.js